import { Box, Typography } from '@mui/material'

import NodeBox from './common/NodeBox'
import Meter from '@assets/flowchart/Meter.svg'
import NodeSelect from './common/NodeSelect'
import { useNodeData } from './common/useNodeData'
import { useReference } from '../ReferenceContext'
import {
  deviceAlertOptions,
  isUnavailableDeviceAlert,
} from '../referenceOptions'

// Core control: a SINGLE device-alert code, sourced from the per-site
// reference bundle (`water_meter.meter_alert_types`) so `data.code` holds a
// real engine code. The serializer emits `{ kind: 'device_alert', code }`.
// Multi-code "any of" authoring is expressible as sibling condition nodes
// (design §C9 — v1 is single-select).
//
// The "active for N days/weeks in a row" duration row was removed (no
// coming-soon UI); it returns WITH its feature once the schema supports a
// duration on device_alert conditions.
const MeterNode = ({ id, data }: { id: string; data: any }) => {
  const patch = useNodeData(id)
  const reference = useReference()
  const alertOptions = deviceAlertOptions(reference, data?.code)
  const opensNoAlerts = isUnavailableDeviceAlert(reference, data?.code)

  return (
    <NodeBox title="התראת מד" icon={Meter} nodeId={id}>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <NodeSelect
          placeholder="סוג התראה"
          options={alertOptions}
          value={data?.code ?? null}
          onChangeValue={v => patch({ code: v })}
        />
        <Typography
          sx={{
            color: '#003F61',
            textAlign: 'right',
            fontFamily: 'Rubik, sans-serif',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 300,
            lineHeight: '100%',
          }}
        >
          {' '}
          התראה של
        </Typography>
      </Box>
      {opensNoAlerts && (
        <Typography
          role="note"
          sx={{
            color: 'warning.main',
            textAlign: 'right',
            fontFamily: 'Rubik, sans-serif',
            fontSize: '12px',
            lineHeight: '130%',
            mt: 1,
          }}
        >
          סוג התראת מכשיר זה אינו פותח התראות
        </Typography>
      )}
    </NodeBox>
  )
}

export default MeterNode
